import { createFileRoute } from "@tanstack/react-router";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MappingMatrix } from "@/components/admin/mapping-matrix";

export const Route = createFileRoute("/_authenticated/admin/mappings")({
  component: MappingsPage,
});

function MappingsPage() {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold text-text-primary">Mappings</h2>
        <p className="text-sm text-muted-foreground mt-0.5">Define relationships between tasks, hazards, controls, and PPE.</p>
      </div>
      <Tabs defaultValue="task-hazards">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="task-hazards">Task-Hazards</TabsTrigger>
          <TabsTrigger value="hazard-controls">Hazard-Controls</TabsTrigger>
          <TabsTrigger value="task-ppe">Task-PPE</TabsTrigger>
        </TabsList>

        <TabsContent value="task-hazards">
          <MappingMatrix mappingType="task-hazards" />
        </TabsContent>

        <TabsContent value="hazard-controls">
          <MappingMatrix mappingType="hazard-controls" />
        </TabsContent>

        <TabsContent value="task-ppe">
          <MappingMatrix mappingType="task-ppe" />
        </TabsContent>
      </Tabs>
    </div>
  );
}
